import classNames from "classnames";
import React, { ReactNode } from "react";

type HeroProps = {
  kind: "solid" | "transparent" | "video" | "solid-arrow";
  video?: BackendConnectionVideo;
  onError?: () => void
  children?: ReactNode;
};

const Hero = (props: HeroProps) => {
  const heroClass = classNames("pt-16 pb-16 md:pt-32 md:pb-32", {
    "bg-c-hero": props.kind === "solid",
    "bg-c-hero relative after:absolute after:-bottom-[86px] after:left-0 after:right-0 after:content after:bg-[url(../images/dark-grey-arrow.png)] after:bg-no-repeat after:bg-center after:h-[86px] mb-20":
      props.kind === "solid-arrow",
  });

  if (props.kind === "video" && props.video) {
    return (
      <div className="flex relative justify-center overflow-hidden pt-16 pb-16 md:pt-32 md:pb-32">
        <div className="h-48 absolute top-0 z-[9] bg-gradient-to-b from-c-hero w-full"></div>
        <div className="w-full h-full bg-c-hero z-[9] absolute top-0 opacity-75"></div>
        <video
          onError={() => props.onError && props.onError()}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full absolute top-1/2 -translate-y-1/2 z-[1] object-cover"
        >
          <source
            src={props.video?.src ?? undefined}
            type={props.video?.type ?? undefined}
          />
        </video>
        <div className="container mx-auto px-5 flex flex-col items-center z-10">
          {props.children}
        </div>
      </div>
    );
  } else {
    return (
      <div className={heroClass}>
        <div className="container mx-auto px-5 flex flex-col items-center">
          {props.children}
        </div>
      </div>
    );
  }
};

export const Magical = ({ num }: { num: number }) => {
  return (
    <div className="relative w-16 h-16 flex justify-center items-center text-2xl text-white mb-3">
      <div className="relative z-[100] mt-2">{num}</div>
      <div className="absolute">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
        >
          <path
            fill="#E84F96"
            d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
          />
        </svg>
      </div>
    </div>
  );
};

export const SubTitle = ({ children }: { children: string }) => {
  return (
    <div className="text-c-subtitle italic font-header text-2xl md:text-3xl uppercase">
      {children}
    </div>
  );
};
export const HeaderTitle = ({ children }: { children: string }) => {
  const titleLength = children.length;
  const longTextStyle =
    "text-2xl md:text-4xl lg:text-7xl font-header uppercase";
  const shortTextStyle =
    "text-4xl md:text-7xl lg:text-8xl font-header uppercase";
  return (
    <div className="text-white mb-5 w-full break-words xl:break-normal lg:w-3/6">
      <span className={titleLength > 12 ? longTextStyle : shortTextStyle}>
        {children}
      </span>
    </div>
  );
};

export const Description = ({ children }: { children: string }) => {
  return (
    <div className="text-white lg:w-3/6 whitespace-pre-line">{children}</div>
  );
};
export const HighlightTitle = ({
  children,
}: {
  children: string[] | string;
}) => {
  return (
    <div className="text-c-highlighttitle italic text-xl md:text-3xl uppercase font-title">
      {children}
    </div>
  );
};
export default Hero;
